import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/app/organizations')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
